import { ID } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { FCAdditionalProps } from "@datassential/platform-ui-lib/lib/core/models";
import { ReactNode } from "react";

interface ITabItem<I extends ID = ID, T extends ReactNode = string> {
    id: I;
    title: T;
}

type Modifier = 'height-m' | 'height-l' | 'item-l' | 'naked';

type Props<I extends ID, T extends ReactNode = string> = FCAdditionalProps & {
    data: ITabItem<I, T>[];
    activeTabId: I;
    onItemClick: (id: I) => void;
    modifiers?: Modifier[];
}

const FoodTabs = <I extends ID = ID, T extends ReactNode = string>({
    data,
    activeTabId,
    onItemClick,
    modifiers = [],
    testId,
    className,
    ...rest
}: Props<I, T>) => {
    return (
        <div
            className={cn(
                className,
                "FoodTabs",
                ...modifiers.map(i => `is-${i}`),
            )}
            data-testid={testId}
            {...rest}
        >
            {data.map(({ id, title }, index) => (
                <div
                    key={id}
                    className={`FoodTabs__item ${activeTabId === id ? 'is-active' : ''}`}
                    onClick={() => onItemClick(id)}
                    data-testid={`buttonFoodTabsItem${index}`}
                >
                    {title as ReactNode}
                </div>
            ))}
        </div>
    );
}

export default FoodTabs;